__turbopack_context__.v({
  "betty-bot-block": "betty-bot-block-module-scss-module__IjxLFq__betty-bot-block",
  "betty-bot-block__instance": "betty-bot-block-module-scss-module__IjxLFq__betty-bot-block__instance",
  "betty-bot-block__loader": "betty-bot-block-module-scss-module__IjxLFq__betty-bot-block__loader",
  "betty-bot-block__logo": "betty-bot-block-module-scss-module__IjxLFq__betty-bot-block__logo",
  "betty-bot-block__logo--desktop": "betty-bot-block-module-scss-module__IjxLFq__betty-bot-block__logo--desktop",
  "betty-bot-block__logo--mobile": "betty-bot-block-module-scss-module__IjxLFq__betty-bot-block__logo--mobile",
});
